"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaysCoveredFallback = exports.buildDaysCoveredI18nParams = exports.DAYS_COVERED_I18N_KEY_MOBILE = exports.DAYS_COVERED_I18N_KEY = void 0;
// Web (web-patient, web-admin, web-ui-library): i18next is configured with
// one namespace per locale file, so the lookup uses colon-separator notation.
exports.DAYS_COVERED_I18N_KEY = 'meals:delivery.daysCovered';
// Mobile: i18next is configured with a single `translation` namespace holding
// the merged locale tree, so the lookup uses dot notation across the path.
// Keep both in lockstep — they resolve to the same translated string.
exports.DAYS_COVERED_I18N_KEY_MOBILE = 'meals.delivery.daysCovered';
// Returns null when the label should be hidden: canceled, zero/negative days,
// or the backend did not report specific weekdays alongside the count.
// `weekdaysCovered` is `readonly string[]` rather than the GraphQL `WeekDay`
// enum because that enum has identical string values but mutually-incompatible
// TS types across `graphql-api-{admin,patient,foodops}`.
var buildDaysCoveredI18nParams = function (daysCovered, weekdaysCovered, options) {
    if (options === void 0) { options = {}; }
    var _a = options.isCanceled, isCanceled = _a === void 0 ? false : _a, _b = options.formatWeekday, formatWeekday = _b === void 0 ? function (d) { return d; } : _b;
    if (isCanceled || daysCovered <= 0 || weekdaysCovered.length === 0) {
        return null;
    }
    return {
        count: daysCovered,
        weekdays: weekdaysCovered.map(formatWeekday).join(', '),
    };
};
exports.buildDaysCoveredI18nParams = buildDaysCoveredI18nParams;
// English fallback string for surfaces without an active i18next provider
// (notably web-admin) and as `Trans` children when a translation is missing.
// Kept here as the single source so all six renderers agree on wording.
var getDaysCoveredFallback = function (params) {
    return "Covers ".concat(params.count, " day").concat(params.count === 1 ? '' : 's', " \u00B7 ").concat(params.weekdays);
};
exports.getDaysCoveredFallback = getDaysCoveredFallback;
